import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-outline",
  templateUrl: "./med-icon-border-outline.component.html",
})
export class MedIconBorderOutlineComponent extends SvgMixinComponent {}
